import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import easing from 'ui/styles/easing'
import getRelativeUrl from 'utils/getRelativeUrl'
import LocalizedString from 'ui/components/generic/LocalizedString'

export default class VideoPlaylist extends Component {
  constructor(props) {
    super(props)

    this.video = React.createRef()
  }

  state = {
    currentVideoIndex: 0,
    videoPlaying: false
  }

  loadVideo = index => {
    this.setState({ currentVideoIndex: index })
  }

  playVideo = () => {
    const { videoPlaying } = this.state

    if(videoPlaying) {
      this.video.current.pause()

      this.setState({ videoPlaying: false })
    } else {
      this.video.current.play()

      this.setState({ videoPlaying: true })
    }
  }
  
  autoPlayVideo = () => {
    this.video.current.play()
    
    this.setState({ videoPlaying: true })
  }

  render() {
    const { videos } = this.props
    const { currentVideoIndex, videoPlaying } = this.state

    return(
      <Wrapper>
        <Container fluid>
          <Row>
            <Col lg={10} lgOffset={1}>
              <VideoContainer onCanPlay={this.autoPlayVideo}>
                <PlayButton videoPlaying={videoPlaying} onClick={this.playVideo}>
                  {videoPlaying ? (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                    </svg>
                  )}
                </PlayButton>
                
                <video ref={this.video} src={videos[currentVideoIndex].video.sourceUrl} />
              </VideoContainer>
            </Col>
          </Row>

          <Row>
            <Col lg={10} lgOffset={1}>
              <PlaylistContainer>
                {videos.map((video, index) => (
                  <Item active={index === currentVideoIndex} key={index}>
                    <TitleBar>
                      <h4>{video.title}</h4>

                      <PlaylistPlayButton onClick={() => this.loadVideo(index)}>
                        {videoPlaying && index === currentVideoIndex ? (
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                        ) : (
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                          </svg>
                        )}
                        <span>
                        <LocalizedString
                          group="genericLabels"
                          string="play"
                        />
                        </span>
                      </PlaylistPlayButton>
                    </TitleBar>

                    <Description>
                      <p>{video.description}</p>
                    </Description>

                    {video.linkText && video.linkUrl && (
                      <a href={getRelativeUrl(video.linkUrl)}>{video.linkText}</a>
                    )}
                  </Item>
                ))}
              </PlaylistContainer>
            </Col>
          </Row>
        </Container>
        
      </Wrapper>
    )
  }
}

// Styles
const Wrapper = styled.section`
  background: #F0F0F0;

`

const VideoContainer = styled.div`
  position: relative;
  height: 0;
  padding-bottom: 56.25%;

  button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 1;
    transition: opacity 0.3s ${easing.easeOutCubic};
  }

  &:hover button {
    opacity: 1;
  }
  
  video {
    width: 100%;
    object-fit: cover;
  }
`

const PlaylistContainer = styled.div`
  display: flex;
  overflow-x: scroll;
  padding-top: 3rem;
  transform: translateY(-3rem);

  ::-webkit-scrollbar-track {
    background-color: ${props => props.theme.colors.tones.lighter};
  }

  ::-webkit-scrollbar {
    width: 0;
    height: 2px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${props => props.theme.colors.primary};
    border: none;
  }
`

const Item = styled.div`
  transform: translateY(${props => props.active ? '-2rem' : 0});
  transition: transform 0.5s ${easing.easeOutCubic};
  min-width: 20rem;
  background: white;
  padding-bottom: 1rem;
  margin-bottom: 1rem;

  a {
    padding: 0.5rem 1rem;
  }

  ${media.xs`
    transform: translateY(${props => props.active ? '-1rem' : 0});
  `}
`

const TitleBar = styled.div`
  display: flex;
  background: ${props => props.theme.colors.tones.lightest};
  height: 2rem;
  justify-content: space-between;
  align-items: center;

  h4 {
    margin: 0;
    padding: 0.5rem 1rem;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
  }
`

const PlayButton = styled.button`
  width: 74px;
  height: 74px;
  background: none;
  color: ${props => props.theme.colors.primary};
  border: none;
  outline: none;
  opacity: ${props => props.videoPlaying ? 0 : 1};
  padding: 0;

  ${media.xs`
    opacity: 1;
  `}

  &:hover {
    cursor: pointer;
    opacity: 1;
  }
`

const PlaylistPlayButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0.5rem 1rem;

  svg {
    width: 20px;
    height: 20px;
    color: ${props => props.theme.colors.primary};
    margin-right: 0.5rem;
  }

  span {
    font-size: 10px;
    text-transform: uppercase;
  }
`

const Description = styled.div`
  padding: 0.5rem 1rem;
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/VideoPlaylist/index.js